'use strict';

const Backbone = require('backbone/backbone');
require('./SectionBlock.less');

const Gallery = require('components/Gallery/Gallery');

module.exports = Backbone.View.extend({
    initialize: function () {
        this.$('.Gallery').each((index, item) => {
            new Gallery({el: item});
        });
    }
});
